<template>
  <validation-provider
    :disabled="!validatable"
    :name="fieldName || label"
    :rules="validatable ? rules : ''"
    :vid="vid"
    v-slot="validationContext"
    slim
  >
    <b-form-group
      v-bind="$attrs"
      :label-cols-sm="noLabel ? undefined : labelColsSm"
      :state="getValidationState(validatable, validationContext)"
      :class="controlClass"
      :label-class="labelClass"
    >
      <template slot="label">
        <div>
          {{ noLabel ? undefined : fieldLabel }}
          <base-help-icon :help-description="helpDescription" />
        </div>
      </template>
      <vue-typeahead-bootstrap
        v-if="search"
        :value="query"
        :data="preparedOptions"
        :minMatchingChars="minMatchingChars"
        :maxMatches="maxMatches"
        :serializer="textFn"
        :inputClass="getValidationClass(validatable, validationContext)"
        :placeholder="placeholder"
        :showOnFocus="showOnFocus"
        @input="input"
        @hit="emitValue"
      />
      <b-form-select
        v-else
        :value="value"
        :options="preparedOptions"
        :text-field="textField"
        :value-field="valueField"
        :state="getValidationState(validatable, validationContext)"
        @change="emitValue"
      />
      <b-form-invalid-feedback
        v-if="validatable"
        :state="getValidationState(validatable, validationContext)"
      >
        {{ validationContext.errors[0] }}
      </b-form-invalid-feedback>
    </b-form-group>
  </validation-provider>
</template>

<script>
import { BaseHelpIcon } from "./";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { baseValidatableMixin } from "@foys-tech/foys-utils";

export default {
  mixins: [baseValidatableMixin],
  components: {
    BaseHelpIcon,
    VueTypeaheadBootstrap,
  },
  data: () => ({
    debounceTimeout: null,
    query: null,
    liveOptions: [],
  }),
  props: {
    minMatchingChars: {
      type: Number,
      default: 0,
    },
    showOnFocus: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
    },
    textFn: {
      type: Function,
      default: (i) => i.name,
    },
    valueFn: {
      type: Function,
      default: (i) => i.id,
    },
    textField: {
      type: String,
      default: "name",
    },
    valueField: {
      type: String,
      default: "id",
    },
    search: {
      type: Boolean,
      default: false,
    },
    showEmptyOption: {
      type: Boolean,
      default: false,
    },
    maxMatches: {
      type: Number,
      default: 10,
    },
    helpDescription: {
      type: String,
      default: null,
    },
    nextTick: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    preparedOptions() {
      if (this.showEmptyOption) {
        let emptyOption = {};
        emptyOption[this.valueField] = null;
        emptyOption[this.textField] = this.$t("common.select_options");
        emptyOption["disabled"] = this.validatable;

        return [emptyOption, ...(this.options || [])];
      } else {
        return this.options || [];
      }
    },
  },
  methods: {
    processInput($event) {
      if (this.search) {
        return $event ? this.valueFn($event) : null;
      }
      return $event;
    },
    input($event) {
      if (!$event) {
        this.emitValue(null);
      }
    },
    loadValue() {
      if (this.search && this.value) {
        let option = this.options.find((e) => this.valueFn(e) == this.value);
        if (option) {
          this.query = this.textFn(option);
        }
      }
    },
  },
  watch: {
    value() {
      this.loadValue();
    },
  },
  created() {
    this.loadValue();
  },
};
</script>
